import { getStorageAuthInfo, cookie } from '@/utils/storageOperateApi';
import { LOCAL_STORAGE_KEY } from '@/constants';
import { isOverseasEnv } from '@/utils/api';

// 海外鉴权头信息
export const getOverseaHeader = (addUid = false) => {
  const isOverseas = isOverseasEnv();
  if (!isOverseas) return {};
  const authInfo = getStorageAuthInfo(LOCAL_STORAGE_KEY.JM_AUTH_INFO);

  const result = {};

  // 如果是海外环境，添加海外相关的请求头
  if (isOverseas) {
    result['overseas-token'] =
      cookie.get(LOCAL_STORAGE_KEY.OVERSEAS_TOKEN) || (authInfo ? authInfo['overseas-token'] : '');
    result['Accept-Language'] = 'en-US';
  }

  if (addUid && authInfo) {
    result.uid = authInfo.uid;
  }
  return result;
};

// 重定向的页面
export const getRedirectUrl = () => {
  return isOverseasEnv() ? '/aiChat/index' : '/activity/roadshow';
};

// 获取头像颜色
export const getAdvarColor = (name) => {
  const colorList = ['#3964E5', '#DE384D', '#F07146', '#8F39E5', '#FF8B8B', '#E5398F'];
  if (!name || !colorList.length) return colorList[0];
  let hash = 0;
  for (let i = 0; i < name.length; i++) hash = (hash << 5) - hash + name.charCodeAt(i);
  const index = Math.abs(hash) % colorList.length;
  return colorList[index];
};

/**
 * 获取短日期格式模板（仅 MM-DD 类，不含 YYYY）
 * 中文：MM-DD → 03-04，英文：MMM-DD → Mar 04
 * @returns {string} dayjs format 字符串
 */
export function getShortDateOversea() {
  return isOverseasEnv() ? 'MMM DD' : 'MM-DD';
}

// 国内：涨红跌绿；海外：涨绿跌红

/**
 * 根据涨跌数值返回颜色 class（无效、零、占位时默认灰色）
 * @param {number|string|null|undefined} value 涨跌幅等数值
 * @returns {string} 'green-color' | 'red-color' | 'grey-color'
 */
export const getStockClassWithDefaultGray = (value) => {
  if (value === null || value === undefined || value === '' || value === '--') return 'grey-color';
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) return 'grey-color';
  const isUp = num > 0;
  return isOverseasEnv() ? (isUp ? 'green-color' : 'red-color') : isUp ? 'red-color' : 'green-color';
};

/**
 * 根据涨跌数值返回颜色类 class（red-color / green-color，用于 stockHeaderOther 等）
 * @param {number|string|null|undefined} value
 * @returns {string} 'red-color' | 'green-color' | ''
 */
export const getColorClassbyNum = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) return '';
  const isUp = num > 0;
  return isOverseasEnv() ? (isUp ? 'green-color' : 'red-color') : isUp ? 'red-color' : 'green-color';
};

/**
 * 根据涨跌数值返回 tooltip 用 style 名（与 .red / .green 对应）
 * @param {number|string|null|undefined} value
 * @returns {string} 'red' | 'green' | ''
 */
export const getStockChangeStyle = (value) => {
  if (value === null || value === undefined || value === '' || Number(value) === 0) return '';
  const num = Number(value);
  if (Number.isNaN(num)) return '';
  const isUp = num > 0;
  return isOverseasEnv() ? (isUp ? 'green' : 'red') : isUp ? 'red' : 'green';
};

/**
 * 根据涨跌数值返回全局字体颜色类名（fcE53939 / fc0EB752 / text-normal）
 * @param {number|string|null|undefined} value
 * @returns {string} 'fcE53939' | 'fc0EB752' |
 */
export const getStockChangeFcClass = (value) => {
  if (value === null || value === undefined || value === '' || Number(value) === 0) return 'text-normal';
  const num = Number(value);
  if (Number.isNaN(num)) return 'fc212533';
  const isUp = num > 0;
  return isOverseasEnv() ? (isUp ? 'fc0EB752' : 'fcE53939') : isUp ? 'fcE53939' : 'fc0EB752';
};

/**
 * 涨时显示的颜色值（用于 ECharts、内联 style）
 * @returns {string}
 */
export const getStockUpColor = () => (isOverseasEnv() ? '#01947b' : '#E53939');

/**
 * 跌时显示的颜色值（用于 ECharts、内联 style）
 * @returns {string}
 */
export const getStockDownColor = () => (isOverseasEnv() ? '#E53939' : '#01947b');

/**
 * 根据涨跌数值返回颜色值（用于 ECharts、内联 style）
 * @param {number|string|null|undefined} value
 * @returns {string|null} 颜色字符串或 null（零/无效时）
 */
export const getStockColorByChange = (value) => {
  if (value === null || value === undefined || value === '') return null;
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) return null;
  return num > 0 ? getStockUpColor() : getStockDownColor();
};

/**
 * 根据涨跌数值返回 up/down 类名（用于 .up/.down 样式，海外时颜色对调）
 * @param {number|string|null|undefined} value
 * @returns {string} 'up' | 'down' | ''
 */
export const getStockUpDownClass = (value) => {
  if (value === null || value === undefined || value === '') return '';
  const num = Number(value);
  if (Number.isNaN(num) || num === 0) return '';
  return num > 0 ? 'up' : 'down';
};

/**
 * 是否需要对调涨跌颜色（海外为 true，用于在模板加 .overseas-stock-color 等 class 切换 CSS）
 * @returns {boolean}
 */
export const isOverseasStockColor = () => isOverseasEnv();

/**
 * 海外版 k线图上升颜色
 * @returns {string}
 */
export const getStockUpColorOversea = () => {
  return isOverseasEnv() ? '#01947B' : '#DE384D';
};

/**
 * 海外版 k线图下跌颜色
 * @returns {string}
 */
export const getStockDownColorOversea = () => {
  return isOverseasEnv() ? '#DE384D' : '#01947B';
};
